var ltr6_module_data = (function (ltr6_module_data) {

    ltr6_module_data.init = function(){
      
    };

    return ltr6_module_data;
}(ltr6_module_data || {}));
